export class PendingApplicationRequest {
    body = {
        ProcessName: "DC Community Portal SR Process Wrapper WF",
        DCMethod: "CHECK_OPEN_SR",
        DCLanguage: "ENU",
        DCLoginName: "",
        DCIncomingHierarchy: {
            MessageId: '',
            IntObjectName: "DC Community Portal SR IO",
            MessageType: "Integration Object",
            IntObjectFormat: "Siebel Hierarchical",
            "ListOfDC Community Portal SR IO": {
                "DC Community Portal SR": {
                    "SR Type": '',
                    "Sub Type": '',
                    "CSN": ''
                }
            }
        }
    }
}